module.exports = __webpack_public_path__ + "img/mac-download2.99d6292b.png";